import React, { useEffect, useState } from 'react';
import {
  Badge, Col, Grid, IconButton, Panel, Row, Stack,
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import { FaFilter } from 'react-icons/fa';
import PricingDataTable from '../components/PricingData/PricingDataTable';
import PricingDataFilter from '../components/PricingData/PricingDataFilter';
import MarketplaceSelector from '../components/PricingData/MarketplaceSelector';
import PricingExport, { PricingExportType } from '../components/PricingData/PricingExport';
import PricingFileImport from '../components/PricingData/PricingFileImport';
import PricingRecalculate from '../components/PricingData/PricingRecalculate';
import PricingReprice from '../components/PricingData/PricingReprice';
import { useStoreActions, useStoreState } from '../store/hooks';
import { getUsedFilterCount } from '../utils/filter';
import { PRICING_ESHOP_PRODUCTS_IMPORT_PATH } from '../api/pricing/pricing';

export default function Pricing() {
  const { fetchEshops } = useStoreActions(actions => actions.catalogs);
  const currentFilter = useStoreState(state => state.pricingData.currentFilter);

  const [filterVisible, setFilterVisible] = useState(false);

  useEffect(() => {
    fetchEshops();
  }, [fetchEshops]);

  function getFiltersCount() {
    const { filter } = currentFilter;
    return getUsedFilterCount(filter, ['marketplaceCodes']);
  }

  const filtersCount = getFiltersCount();

  const FilterButton = (
    <IconButton
      style={{ width: 150 }}
      appearance="primary"
      onClick={() => setFilterVisible(!filterVisible)}
      placement="right"
      icon={<Icon as={FaFilter} />}
    >
      Advanced filter
    </IconButton>
  );

  return (
    <Panel className="h100p">
      <Grid fluid className="h100p">
        <Row>
          <Col xs={24}>
            <Stack direction="column" alignItems="flex-start" spacing={10} className="mt-20">
              <Stack spacing={40}>
                <MarketplaceSelector />

                {filtersCount > 0 ? (
                  <Badge content={filtersCount} color="green">
                    {FilterButton}
                  </Badge>
                ) : FilterButton}
              </Stack>

              <Stack spacing={20} wrap>
                <PricingFileImport
                  path={PRICING_ESHOP_PRODUCTS_IMPORT_PATH}
                  label="Import pricing products"
                />

                <PricingExport type={PricingExportType.PRICES_UPDATE} />

                <PricingExport type={PricingExportType.PRICING_DATA} />

                <PricingRecalculate />

                <PricingReprice />
              </Stack>

              <PricingDataFilter
                visible={filterVisible}
              />
            </Stack>
          </Col>
        </Row>
        <Row className={filterVisible ? 'pricing-table-container-filter' : 'pricing-table-container'}>
          <Col xs={24} className="mt-20 h100p">
            <PricingDataTable />
          </Col>
        </Row>
      </Grid>
    </Panel>
  );
}
